module.exports = __webpack_public_path__ + "img/chinesecompany25.08643ef7.png";